import * as React from 'react'
import { ShopifyNext } from '@dotdev/next-components'
import { GlobalProps } from 'types'
import * as Snippets from 'snippets'
import * as Helpers from 'helpers'
import { trackPromotionClick } from 'helpers'

export class FeaturedCollection extends React.PureComponent<FeaturedCollection.Props, FeaturedCollection.State> {
  public static sectionId = 'feacol';

  constructor(props: FeaturedCollection.Props) {
    super(props)
    this.state = {
      activeCollection: 1,
      blocks: {},
      wishlist: []
    }
  }

  private static kewl = new Helpers.ShopifyKewl({
    //@ts-ignore
    store: STOREFRONT_NAME,
    //@ts-ignore
    storeFrontKey: STOREFRONT_PASSWORD
  })
  
  componentDidMount(): void {
    this.fetchWishlistItems()
  }

  
  public fetchWishlistItems = () => {
    if (!window._swat || !window._swat.retailerSettings) {
      // console.error('Swat is not initialized')
      setTimeout(() => {
        // console.log('Swat is initialized')
        this.fetchWishlistItems()
      }, 1000)
    } else {
      window._swat?.fetch((res: any) => {
        // console.log('res:', res)
        this.setState({ wishlist: res })
        document.dispatchEvent(new CustomEvent('swym:wishlist-fetched'))
      })
    }
  };
  
  public checkWishlistItem = (product: any) => {
    const { wishlist } = this.state
    const productId = typeof product.id === 'number' ? product.id : parseInt(product.id?.split('/').pop())
    const productVariantId = typeof product.variants[0]?.id === 'number' ? product.variants[0]?.id : parseInt(product.variants[0]?.id.split('/').pop())
    // console.log('wishlist', wishlist)
    // console.log('product', product)
    if (wishlist.length === 0) {
      console.warn('wishlist is empty')
      return false
    }

    // check if item.id matches any of the res.epi
    const isRes = wishlist.some((r: any) => {
      return r.epi === productId || 
        r.empi === productId || 
        r.epi === productVariantId
    })

    if (isRes) {
      // console.log('wishlist item found')
      return true
    }
    // console.log('wishlist item not found')
    return false
  };
  
  public toggleWishlist = (product: any, isInList: boolean): void => {
    const _this = this
    
    const productId = typeof product.id === 'number' ? product.id : parseInt(product.id?.split('/').pop())
    const productVariantId = typeof product.variants[0]?.id === 'number' ? product.variants[0]?.id : parseInt(product.variants[0]?.id.split('/').pop())
    
    const productData = {
      ...window.SwymPageData,
      et: 4, // et 4 stands for wishlist event type
      epi: productVariantId, // unique variant ID of the product.
      empi: productId, // Product ID or master product ID
      du: `${window.location.origin}/products/${product.handle}`
    }
    
    if (isInList) {
      window._swat.removeFromWishList(
        productData,
        function (e: any) {
          console.log('wishlist item removed', e)
          document.dispatchEvent(new CustomEvent('swym:wishlist-updated'))
          _this.fetchWishlistItems()
        },
        function (e: any) {
          console.log('wishlist item failed', e)
        }
      )
    } else {
      window._swat.addToWishList(
        productData,
        function (e: any) {
          console.log('wishlist item added', e)
          document.dispatchEvent(new CustomEvent('swym:wishlist-updated'))
          _this.fetchWishlistItems()
        },
        function (e: any) {
          console.log('wishlist item failed', e)
        }
      )
    }
  }

  public componentDidUpdate = async (prevProps) => {
    if (typeof prevProps.section.blocks === 'undefined'
      && this.props.section.blocks.length) {
      this.props.section.blocks.forEach(async (block, i) => {
        if (Helpers.check(block, 'block.settings.collection.products')) {
          const products = await this.getSwatchdata(block.settings.collection.products.slice(0, 6))
          this.setState(prevState => {
            return {
              blocks: {
                ...prevState.blocks,
                [i]: products
              }
            }
          })
        }
      })
    }
  }
  
  private getSwatchdata = async (products) => {
    const tags = []
    products.forEach(product => {
      tags.push(`colours:${[product.handle]}`)
    })
    const siblingsResults = await FeaturedCollection.kewl.productsBySwatchTags(tags)
    const newProducts = []
    products.forEach(product => {
      const underlinedHandle = product.handle.replace(/\-/g, '_')// eslint-disable-line no-useless-escape
      const siblingsQuantity = siblingsResults[underlinedHandle].length
      const filteredSiblings = siblingsResults[underlinedHandle].filter(sibling => sibling.handle !== product.handle)
      newProducts.push({ ...product, siblingsQuantity: siblingsQuantity, filteredSiblings: filteredSiblings })
    })
    return newProducts
  }

  public render(): JSX.Element {
    const { section } = this.props
    const { article } = this.props.data.section
    // Allow full width is used to remove overall parent container width constraints to allow articles to have full width images 
    let allow_full_width_images = article?.settings?.allow_full_width_images
    const { blocks } = section

    const sliderSettings = {
      adaptiveHeight: false,
      autoplay: false,
      autoplaySpeed: 4000,
      dots: false,
      arrows: true,
      infinite: true,
      pauseOnHover: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      swipeToSlide: false,
      centerMode: true,
      centerPadding: '98px',
      speed: 500,
      responsive: [{
        breakpoint: 1100,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerPadding: '35px'
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: '35px'
        }
      }
      ],
      prevArrow: (
        <div>
          <button className={'outline-none w-4 h-4 flex justify-center items-center absolute bottom-0 opacity-30 hover:opacity-100'}>
            <span className={'block text-black'}>
              <Snippets.Icon name={'chevron_left'} width={18} label={'previous slide'}/>
            </span>
          </button>
        </div>
      ),
      nextArrow: (
        <div>
          <button className={'outline-none w-4 h-4 flex justify-center items-center absolute bottom-0  opacity-30 hover:opacity-100'}>
            <span className={'block text-black border'}>
              <Snippets.Icon name={'chevron_right'} width={18} label={'next slide'}/>
            </span>
          </button>
        </div>
      ),
      appendDots: (dots: any) => {
        return (
          <div>
            <div className={'slick-dots absolute bottom-0 inset-x-0'}>
              <ul className={'text-center list-reset'}>{dots}</ul>
            </div>
          </div>
        )
      },
      customPaging: () => {
        return (
          <button
            className={
              'inline-block rounded-full bg-blue-40 border border-transparent outline-none focus:outline-none p-0-5 mx-0-5 transition'
            }
          />
        )
      }
    }

    return (
      <section className={`dynamic-collection ${allow_full_width_images ? 'max-w-7xl mx-auto' : ''} `}>
        <div className={'max-w-8xl pl-1-6 sm:pl-2-4 xl:pl-22 lg:pl-2-8 mx-auto text-center pb-3-2'}>
          {this.props.section.block_size > 1 ?
            <div className={'flex flex-nowrap overflow-y-hidden overflow-x-auto'}>
              {blocks && blocks.length > 0
                ? blocks.map((block: any, i: number) => {
                  const count = i + 1
                  return (
                    <div key={i} className={'mr-2 py-2-4 mr-3-2 text-left'}>
                      <Snippets.Heading
                        tag={'p'}
                      >
                        <a
                          className={`block-${i} cursor-pointer uppercase font-bold block tracking-wide text-xs transition hover:opacity-100
                          ${this.state.activeCollection && (this.state.activeCollection == count) ? ' ' : 'opacity-30'} sm:min-w-auto min-w-10`}
                          onClick={() => this.setState({ activeCollection: count })}
                        >
                          {block.settings.label ?
                            block.settings.label
                            : block.settings.collection.title}
                        </a>
                      </Snippets.Heading>
                    </div>
                  )
                })
                : null
              }
            </div>
            : null}
          <div className={'relative'}>
            {blocks && blocks.length > 0
              ? blocks.map((block: any, i: number) => {
                const icount = i + 1
                return (
                  <div className={`
                ${icount != 1 ? 'absolute inset-0' : 'relative'}
                ${this.state.activeCollection} ${this.state.activeCollection && this.state.activeCollection == icount ? 'visible z-10' : 'invisible'} bg-white flex max-w-full w-full flex-wrap pb-4`} key={i}>
                    <div className={'w-full lg:w-1/3 lg:pr-3 pr-1-6 lg:text-left text-center sm:pt-4-2 pt-3-6'}>
                      {block.settings.title ?
                        <Snippets.Heading
                          tag={'h2'}
                          size={'h1'}
                          className={'sm:mb-3-2 mb-2 leading-none'}
                        >
                          {block.settings.title}
                        </Snippets.Heading>
                        : null}

                      {block.settings.content ?
                        <Snippets.RichText className={'mt-2 leading-base'}>
                          {block.settings.content}
                        </Snippets.RichText>
                        : null}

                      {block.settings.linktext ? (
                        <Snippets.Button
                          onClick={() => trackPromotionClick(
                            [{
                              id: section.id,
                              name: block.settings.title,
                              creative: 'Collection section',
                              position: `${i}`
                            }],
                            block.settings.linkurl
                          )}
                          className={'mt-2-9 md:mt-3 mx-0-3 font-bold text-xs uppercase tracking-wider lg:mb-0 mb-4 py-1'}
                          colour={'secondary'}
                          title={block.settings.linktext}
                          thin={true}
                        >
                          {block.settings.linktext}
                        </Snippets.Button>
                      ) : null}
                    </div>

                    <div className={'w-full lg:w-2/3 pb-1-6'}>
                      <Snippets.Slider
                        className={'border-r border-grey-200'}
                        settings={{ ...sliderSettings }}
                      >
                        {this.state.blocks[i] && this.state.blocks[i].length ?
                          this.state.blocks[i].map((product: any, i: number) => {
                            return (
                              <div key={i}>
                                <Snippets.CollectionProduct
                                  product={product}
                                  className={'w-full'}
                                  preventLazy
                                  list="Collection Section"
                                  collection={Helpers.check(this, 'this.props.data.collection') ? this.props.data.collection : null}
                                  isInWishlist={this.checkWishlistItem(product)}
                                  toggleWishlist={this.toggleWishlist}
                                  wishlist={this.state.wishlist}
                                />
                              </div>
                            )
                          }) : null}
                      </Snippets.Slider>
                    </div>

                  </div>
                )
              })
              : Array.from({ length: this.props.section.block_size }).map((_val: undefined, i: number) => {
                return (
                  <div key={i}>
                    <Snippets.CollectionProduct
                      product={'placeholder'}
                      className={'w-full'}
                      list="Collection Section"
                      isInWishlist={false}
                      toggleWishlist={this.toggleWishlist}
                      wishlist={this.state.wishlist}
                    />
                  </div>
                )
              })
            }

          </div>
        </div>
      </section>
    )
  }
}

export namespace FeaturedCollection {
  export interface Options extends ShopifyNext.Section<{
    slidestoshow: string | number;
  }> {
    block_size: number;
  }

  export interface Props extends GlobalProps {
    section: FeaturedCollection.Options;
  }
  export interface State {
    activeCollection: number;
    blocks: any;
    wishlist: any[];
  }
}
